import { useState } from 'react';
import { NudosButton, NudosUploadDownloadButton } from '../../../../NudosComponents';
import { validateImageOrPdfCallback } from '../../../../../utils/validateFiles';

import './ExternalWipingModal.scss';

const ExternalWipingModalContent = ({
  markExternalWiping
}: {
  markExternalWiping: (file?: File, loadingHandler?: React.Dispatch<React.SetStateAction<boolean>>) => Promise<void>;
}) => {
  const [proofFile, setProofFile] = useState<File>();
  const [loading, setLoading] = useState(false);

  const submitModal = () => markExternalWiping(proofFile, setLoading);

  const uploadProofFile = (file?: File) => {
    if (!file) return;
    setProofFile(file);
  };

  return (
    <div className="externalWipingModalContent">
      <div className="subtitle orangeText">Sube una evidencia del servicio de Wiping para marcarlo como completado</div>
      <NudosUploadDownloadButton
        customClassName="externalWipingProofUploadButton"
        customWidth="127px"
        uploadedFileHandler={uploadProofFile}
        downloadButtonText="Consultar evidencia"
        buttonEmptyText="PDF o JPG"
        buttonFilledText="PDF o JPG"
        showSkeletonLoader={false}
        keepOwnFileState={true}
        validateFileCallback={validateImageOrPdfCallback}
      />
      <div className="verificationQuestion orangeText">¿Seguro que deseas continuar?</div>
      <NudosButton
        componentSize="small"
        buttonText="Marcar como completado"
        handleClick={submitModal}
        isButtonDisabled={!proofFile}
        isButtonLoading={loading}
      />
    </div>
  );
};

export default ExternalWipingModalContent;
